var $1ab61de85823a0b7$exports = {};
$1ab61de85823a0b7$exports = {
    "expand": `Expand`,
    "collapse": `Collapse`
};


export {$1ab61de85823a0b7$exports as default};
//# sourceMappingURL=en-US.module.js.map
